import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage1 from '../HomePage1.vue'
import MapPage1 from '../MapPage1.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage1',
    component: HomePage1
  },
  {
    path: '/:mappage',
    name: 'MapPage1',
    component: MapPage1
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition){
        return savedPosition
    }
    else{
      return { 
        top: 0 
      }
    }
  }
})

export default router
